import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=22f877d0&scoped=true"
import script from "./BarChart.vue?vue&type=script&lang=js"
export * from "./BarChart.vue?vue&type=script&lang=js"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=22f877d0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f877d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22f877d0')) {
      api.createRecord('22f877d0', component.options)
    } else {
      api.reload('22f877d0', component.options)
    }
    module.hot.accept("./BarChart.vue?vue&type=template&id=22f877d0&scoped=true", function () {
      api.rerender('22f877d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/applications/components/BarChart.vue"
export default component.exports